import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconLockBold: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;

  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.625 8.9999H8.8125V6.7499C8.8125 5.90146 9.14531 5.10459 9.75 4.4999C10.3547 3.89521 11.1516 3.5624 12 3.5624C12.8484 3.5624 13.6453 3.89521 14.25 4.4999C14.8547 5.10459 15.1875 5.90146 15.1875 6.7499C15.1875 7.11084 15.4828 7.40615 15.8438 7.40615C16.2047 7.40615 16.5 7.11084 16.5 6.7499C16.5 4.25615 14.4422 2.21709 11.9391 2.2499C9.46875 2.28271 7.5 4.33584 7.5 6.81084V8.9999H6.375C5.34375 8.9999 4.5 9.84365 4.5 10.8749V19.8749C4.5 20.9062 5.34375 21.7499 6.375 21.7499H17.625C18.6562 21.7499 19.5 20.9062 19.5 19.8749V10.8749C19.5 9.84365 18.6562 8.9999 17.625 8.9999ZM12.6562 14.8499V18.0749C12.6562 18.4265 12.3844 18.7312 12.0328 18.7499C11.6578 18.7687 11.3438 18.4687 11.3438 18.0937V14.8499C10.8047 14.5874 10.4484 14.0155 10.5047 13.364C10.5703 12.6374 11.1656 12.0562 11.8922 12.0046C12.7688 11.9437 13.5 12.6374 13.5 13.4999C13.5 14.0952 13.1578 14.6062 12.6562 14.8499Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconLockBold;
